<template>
    <div v-if="hasAuth('Admin')">
        <list-container :header="translate('categoryList.categories')" v-show="!$route.params.id">
            <template v-slot:commands>
                <excel-exporter table-id="categoryExport" :columns="columns" url="/category/get" modelName="Category" orderBy="Name"></excel-exporter>
                <button class="btn btn-primary" @click="$router.push({ name:'CategoryDetail', params: { id: '000000000000000000000000' } })">
                    {{translate('categoryList.newCategory')}}
                </button>
            </template>
            <list :columns="columns" url="/category/get" modelName="Category" orderBy="IsActive desc,Name">
            </list>
        </list-container>
        <router-view v-if="$route.params.id"/>
    </div>
    <div v-else class="alert alert-danger">
        {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
</template>

<script>
import list from '../components/List.vue'
import listContainer from '../components/ListContainer.vue'
import Vue from 'vue'
import ExcelExporter from '../components/ExcelExporter.vue';

export default {
    data(){
        return {
            columns : [
                {
                    Key: "Name",
                    Title: this.translate('categoryList.columns.name'),
                    SortField: "Name"
                },
                {
                    Key: "Type",
                    Title: this.translate('categoryList.columns.type'),
                    SortField: "Type",
                    Content(i){
                        return Vue.filter('documentType')(i.Type);
                    }
                },
                {
                    Key: "IsActive",
                    Title: this.translate('categoryList.columns.active'),
                    SortField: "IsActive",
                    Class: "text-center",
                    Style: "width:1px",
                    Content(i) {
                        return Vue.filter('checkicon')(i.IsActive);
                    }
                }
            ]
        }
    },
    components: {
        list,
        ExcelExporter,
        listContainer
    }
}
</script>